'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconFilter, iconFilterTag } from '@ni/nimble-components/dist/esm/icons/filter';
import { wrap } from '../../utilities/react-wrapper';

export type { IconFilter };
export { iconFilterTag };
export const NimbleIconFilter = wrap(IconFilter);